import React, { useContext, useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import NavbarWrapper from 'common/components/Navbar';
import Drawer from 'common/components/Drawer';
import Button from 'common/components/Button';
import Logo from 'common/components/UIElements/Logo';
import Box from 'common/components/Box';
import HamburgMenu from 'common/components/HamburgMenu';
import Container from 'common/components/UI/Container';
import { DrawerContext } from 'common/contexts/DrawerContext';
import ScrollSpyMenu from 'common/components/ScrollSpyMenu';

// import LogoImage from 'common/assets/image/saasModern/logo-white.png';
// import LogoImageAlt from 'common/assets/image/saasModern/logo.png';

import LogoImage from 'common/assets/image/saasModern/CloudPouchLogoNegative.png';
import LogoImageAlt from 'common/assets/image/saasModern/CloudPouchLogo.png';
import TrialDownloadButton from '../../Custom/TrialDownloadButton';


const Navbar = ({ navbarStyle, logoStyle, button, row, menuWrapper }) => {
  const Data = useStaticQuery(graphql`
    query {
      saasModernJson {
        MENU_ITEMS {
          label
          labelPrefix
          path
          offset
          staticLink
        }
      }
    }
  `);

  const { state, dispatch } = useContext(DrawerContext);

  // At the very top of the page no menu item is current: the lower hero lets
  // the demo section into the first screen, which would light up "Demo".
  const [atTop, setAtTop] = useState(true);
  useEffect(() => {
    const onScroll = () => setAtTop(window.scrollY < 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const currentClassName = atTop ? 'is-idle' : 'is-current';

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: 'TOGGLE',
    });
  };

  return (
    <NavbarWrapper {...navbarStyle} className="saas_navbar">
      {/* Same edges as the hero below it (5vw gutters, see Banner). */}
      <Container width="min(calc(90vw + 60px), 2260px)">
        <Box {...row}>
          <Logo
            href="#banner_section"
            logoSrc={LogoImage}
            title="CloudPouch — See. Understand. Reduce AWS costs."
            logoStyle={logoStyle}
            className="main-logo"
          />
          <Logo
            href="#banner_section"
            logoSrc={LogoImageAlt}
            title="CloudPouch — See. Understand. Reduce AWS costs."
            logoStyle={logoStyle}
            className="logo-alt"
          />
          <Box {...menuWrapper}>
            <ScrollSpyMenu
              className="main_menu"
              menuItems={Data.saasModernJson.MENU_ITEMS}
              currentClassName={currentClassName}
              offset={-70}
            />
            <TrialDownloadButton className="navbar_button" title='START FREE' location="nav"/>
            <Drawer
              width="420px"
              placement="right"
              drawerHandler={
                <HamburgMenu
                  barColor="#fff"
                  type="button"
                  aria-label={state.isOpen ? 'Close menu' : 'Open menu'}
                  aria-expanded={state.isOpen ? 'true' : 'false'}
                />
              }
              open={state.isOpen}
              toggleHandler={toggleHandler}
            >
              <ScrollSpyMenu
                className="mobile_menu"
                menuItems={Data.saasModernJson.MENU_ITEMS}
                drawerClose={true}
                currentClassName={currentClassName}
                offset={-100}
              />
              <TrialDownloadButton className="navbar_drawer_button" title='START FREE' location="nav"/>
            </Drawer>
          </Box>
        </Box>
      </Container>
    </NavbarWrapper>
  );
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object,
};

Navbar.defaultProps = {
  navbarStyle: {
    minHeight: '70px',
    display: 'block',
  },
  row: {
    flexBox: true,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  logoStyle: {
    maxWidth: ['130px', '256px'],
  },
  button: {
    type: 'button',
    fontSize: '13px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '15px',
    pr: '15px',
    colors: 'secondaryWithBg',
    minHeight: 'auto',
    height: '40px',
  },
  menuWrapper: {
    flexBox: true,
    alignItems: 'center',
  },
};

export default Navbar;
